import store from 'utils/store/withMiddleware'
import getUrlProfile from 'utils/pivot/member/getURLProfile'
import { propAccessor } from '@hc-frontend/utils'
import getURLParams from 'utils/DOM/getURLParams'
import storage from 'proxy-storage'

export const pickExisting = data =>
  Object.entries(data).reduce((acc, [key, value]) => {
    if (typeof value === 'boolean' || value) {
      acc[key] = value
    }
    return acc
  }, {})

export const contactParameters = state =>
  pickExisting({
    firstName: propAccessor(state, 'hcStorage.contact.first_name'),
    email: propAccessor(state, 'hcStorage.contact.email_address')
  })

export const primaryMemberParameters = state => {
  const primaryMember =
    state.hcStorage.members &&
    state.hcStorage.members.length &&
    state.hcStorage.members.find(m => m.id === 'primary')

  if (!primaryMember) {
    return {}
  }

  return pickExisting({
    firstName: primaryMember.firstName,
    lastName: primaryMember.lastName,
    email: primaryMember.email
  })
}

export const planParameters = state => {
  if (state.planId) {
    const plan = state.plans[state.planId]
    const policies = propAccessor(state, 'filters.policies')
    const period = plan.multiCarrierPlan ? '120' : propAccessor(state, 'filters.period')

    // Important assumptions for the premium rate;
    // - For multicarrier the durations prop is an array and the premium rate picked from the first element
    // - For single carrier the durations prop is an object and the premium rate picked form the period and considering 1 policy
    const quotedPremium =
      plan.durations instanceof Array
        ? plan.durations[0].monthly.premium
        : propAccessor(plan, ['durations', period, 1, 'monthly', 'premium'])

    return pickExisting({
      planName: plan.planName,
      isMulticarrier: plan.multiCarrierPlan,
      effectiveDate: state.sDate,
      planDuration: period ? `${policies ? `${policies}X` : ''}${period}` : undefined,
      quotedPremium
    })
  }
}

export const urlQueryParameters = () => {
  const urlParams = getURLParams()

  return pickExisting({
    firstName: urlParams['fname'],
    lastName: urlParams['lname'],
    email: urlParams['email'],
    agentId: urlParams['agent_id'],
    quoteKey: urlParams['quoteKey']
  })
}

export const createLink = (state, placementUrl, agentId) =>
  `https://${window.location.hostname}${placementUrl}?${getUrlProfile({
    stateRef: state,
    addPlanId: true,
    agentId,
    addProfile: true,
    addQuoteKey: true
  })}`

export const getState = storeRef => {
  if (storeRef && storeRef.hcStorage && storeRef.quoteKey) {
    return storeRef
  } else if (storeRef && storeRef.getState) {
    return storeRef.getState()
  } else {
    return store.getState()
  }
}

export const getBaseParameters = state => {
  const enrollment =
    propAccessor(state, 'enrollment') ||
    propAccessor(state, 'hcStorage.enrollment') ||
    storage.getItem('enrollment')

  return pickExisting({
    quoteKey:
      propAccessor(state, 'quoteKey') || propAccessor(state, 'hcStorage.quoteKey'),
    agentId:
      propAccessor(state, 'agentInfo.agentId') ||
      propAccessor(state, 'hcStorage.agent_id'),
    status: enrollment ? 'SUBMITTED_APPLICATION' : undefined
  })
}
